import axios from "axios";

export async function login(username, password) {
	if (!username || !password) {
		throw new Error("Both username and password are required.");
	}
	const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/login`, {
		username,
		password,
	});
	return response.data;
}
